import React from "react";

export const Logo = ({className = ""}) => {
  return (
    <svg className={className}
      version="1.1"
      id="svg2"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 992.1 392.4"
      style={{ enableBackground: "new 0 0 992.1 392.4" }}
      xmlSpace="preserve"
    >
      <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,392.4)">
        <g id="g12" transform="scale(0.1)">
          <path
            id="path14"
            className="st0"
            d="M1630.8,2010.6l-122.2,262.1l-119.7-262.1H1630.8z M1443,2498.2h134.8l415.8-882H1811
			l-110.9,239.4h-383l-110.9-239.4H1026L1443,2498.2"
          />
          <path
            id="path16"
            className="st0"
            d="M2093.9,1666c-39.1,43.3-59.9,103.5-62.4,180.8v399.4h151.2v-370.4c0-45.4,8.4-77.9,25.2-97.7
			c16.8-19.8,47.4-29.6,92-29.6c44.5,0,86.1,10.9,124.7,32.8c38.6,21.8,58,55,58,99.5v365.4h152.5v-630h-151.2v73.1
			c-59.7-58.8-134-88.2-223-88.2C2188.6,1601.1,2133,1622.7,2093.9,1666"
          />
          <path
            id="path18"
            className="st0"
            d="M2812.7,1657.1c-53.8,35.7-80.6,91.8-80.6,168.2h153.7c0-31.9,13.4-53.4,40.3-64.3
			c26.9-10.9,60.9-16.4,102.1-16.4c52.9,0,90.5,4.8,112.8,14.5c22.3,9.6,33.4,26.7,33.4,51c0,20.2-8.8,35.7-26.5,46.6
			c-17.6,10.9-46.2,19.3-85.7,25.2l-78.1,10.1c-60.5,7.6-108.6,17.6-144.3,30.2c-35.7,12.6-62.8,31.3-81.3,56.1
			c-18.5,24.8-27.7,58.2-27.7,100.2c0,59.6,26.6,106.9,80,141.8c53.3,34.9,122.4,52.3,207.3,52.3c83.2,0,152-17.4,206.6-52.3
			c54.6-34.9,84-87.2,88.2-156.9h-151.2c0,26-12.6,43.9-37.8,53.6c-25.2,9.6-60.5,14.9-105.8,15.8c-48.7-0.9-83.8-6.3-105.2-16.4
			c-21.4-10.1-32.1-25.2-32.1-45.4c0-16.8,8-29.6,23.9-38.4c15.9-8.8,44.1-16.2,84.4-22.1l86.9-11.3c63-7.6,112.6-18.7,148.7-33.4
			c36.1-14.7,62.6-34.7,79.4-59.8c16.8-25.2,25.2-58.8,25.2-100.8c0-62.2-26.3-111.3-78.8-147.4c-52.5-36.1-127.5-54.6-224.9-55.4
			C2937.4,1603.2,2866.4,1621.4,2812.7,1657.1"
          />
          <path
            id="path20"
            className="st0"
            d="M3810.6,2498.2h152.5v-467.5l292.3,219.2h234.4l-302.4-229.3l294.9-404.5h-186.5l-230.6,317.5
			l-102.1-76.9v-240.7h-152.5V2498.2"
          />
          <path
            id="path22"
            className="st0"
            d="M4903.7,1766.8c34,21.4,51,50.6,51,87.6v59.2l-94.5-3.8c-80.6-3.4-136.9-12.4-168.8-27.1
			c-31.9-14.7-47.9-37.6-47.9-68.7c0-25.2,10.5-44.7,31.5-58.6c21-13.9,52.9-20.8,95.8-20.8
			C4825.3,1734.6,4869.6,1745.3,4903.7,1766.8L4903.7,1766.8z M4557.8,1664.1c-44.5,34.4-66.8,85.7-66.8,153.7
			c0,56.3,16.4,99.1,49.1,128.5c32.8,29.4,75.6,49.1,128.5,59.2s117.2,15.5,192.8,16.4l93.3,1.3v8.8c0,38.6-10.1,65.1-30.3,79.4
			c-20.1,14.3-55.9,21.4-107.1,21.4c-42.8,0-76.2-6.3-100.2-18.9c-24-12.6-36.4-36.1-37.2-70.6h-156.2
			c0.8,81.5,27.3,139.9,79.4,175.2c52.1,35.3,123.5,53.3,214.2,54.2c100-0.9,173-21.4,219.2-61.7c46.2-40.3,69.3-101.2,69.3-182.7
			v-412h-151.2v79.4c-24.4-25.2-54.4-45.4-90.1-60.5c-35.7-15.1-76.7-22.7-122.9-22.7C4663.6,1612.4,4602.3,1629.6,4557.8,1664.1"
          />
          <path
            id="path24"
            className="st0"
            d="M5271.6,1666c-39.1,43.3-59.9,103.5-62.4,180.8v399.4h151.2v-370.4c0-45.4,8.4-77.9,25.2-97.7
			c16.8-19.8,47.5-29.6,92-29.6c44.5,0,86.1,10.9,124.7,32.8c38.6,21.8,58,55,58,99.5v365.4h152.5v-630h-151.2v73.1
			c-59.7-58.8-134-88.2-223-88.2C5366.3,1601.1,5310.6,1622.7,5271.6,1666"
          />
          <path
            id="path26"
            className="st0"
            d="M6374,1793.9c31.5,31.9,47.3,80.6,47.3,146.2c0,63.8-15.8,111.5-47.3,143
			c-31.5,31.5-74.1,47.3-127.9,47.3c-59.6,0-105.8-15.1-138.6-45.4c-32.8-30.2-49.1-70.2-49.1-119.7v-49.1
			c0-54.6,14.9-96.6,44.7-126c29.8-29.4,75-44.1,135.5-44.1C6297.4,1746,6342.6,1761.9,6374,1793.9L6374,1793.9z M5907.2,2262.6
			h152.5v-79.4c18.5,29.4,45.4,51.7,80.6,66.8c35.3,15.1,74.8,22.7,118.5,22.7c66.4,0,123.7-13.9,172-41.6
			c48.3-27.7,85.3-66.6,110.9-116.6c25.6-50,38.4-108.2,38.4-174.5c0-68-13.7-127.5-41-178.3c-27.3-50.8-66-90.1-115.9-117.8
			c-50-27.7-109-41.6-177-41.6c-80.6,0-142.8,23.1-186.5,69.3v-258.3h-152.5V2262.6"
          />
          <path
            id="path28"
            className="st0"
            d="M6706.1,1727.7c15.9,13.9,34.9,20.8,56.7,20.8c21,0,39.5-6.9,55.4-20.8
			c16-13.9,23.9-33,23.9-57.3c0-24.4-8-43.5-23.9-57.3c-16-13.9-34.5-20.8-55.4-20.8c-21.9,0-40.8,6.9-56.7,20.8
			c-16,13.9-23.9,32.9-23.9,57.3C6682.1,1694.7,6690.1,1713.8,6706.1,1727.7"
          />
          <path
            id="path30"
            className="st0"
            d="M1192.7,1068l-122.2,262.1L950.8,1068H1192.7z M1004.9,1555.6h134.8l415.8-882h-182.7L1262,913
			h-383L768.1,673.6H587.9L1004.9,1555.6"
          />
          <path
            id="path32"
            className="st0"
            d="M1665.8,723.4c-39.1,43.3-59.8,103.5-62.4,180.8v399.4h151.2V933.2c0-45.4,8.4-77.9,25.2-97.7
			c16.8-19.8,47.4-29.6,92-29.6c44.5,0,86.1,10.9,124.7,32.8c38.6,21.8,58,55,58,99.5v365.4H2207v-630h-151.2v73.1
			c-59.7-58.8-134-88.2-223-88.2C1760.5,658.5,1704.9,680.1,1665.8,723.4"
          />
          <path
            id="path34"
            className="st0"
            d="M2384.6,714.6c-53.8,35.7-80.6,91.8-80.6,168.2h153.7c0-31.9,13.4-53.3,40.3-64.3
			c26.9-10.9,60.9-16.4,102.1-16.4c52.9,0,90.5,4.8,112.8,14.5c22.3,9.6,33.4,26.7,33.4,51c0,20.2-8.8,35.7-26.5,46.6
			c-17.6,10.9-46.2,19.3-85.7,25.2l-78.1,10.1c-60.5,7.6-108.6,17.6-144.3,30.2c-35.7,12.6-62.8,31.3-81.3,56.1
			c-18.5,24.8-27.7,58.2-27.7,100.2c0,59.6,26.7,106.9,80,141.8c53.3,34.8,122.4,52.3,207.3,52.3c83.2,0,152-17.4,206.6-52.3
			c54.6-34.9,84-87.2,88.2-156.9h-151.2c0,26-12.6,43.9-37.8,53.6c-25.2,9.7-60.5,14.9-105.8,15.8c-48.7-0.8-83.8-6.3-105.2-16.4
			s-32.1-25.2-32.1-45.4c0-16.8,8-29.6,23.9-38.4c15.9-8.8,44.1-16.2,84.4-22.1l86.9-11.3c63-7.6,112.6-18.7,148.7-33.4
			c36.1-14.7,62.6-34.7,79.4-59.8c16.8-25.2,25.2-58.8,25.2-100.8c0-62.2-26.3-111.3-78.8-147.4c-52.5-36.1-127.5-54.6-224.9-55.4
			C2509.4,660.6,2438.4,678.9,2384.6,714.6"
          />
          <path
            id="path36"
            className="st0"
            d="M3382.5,1320H3535v-79.4c21.8,25.2,49.6,46,83.2,62.4c33.6,16.4,66.8,25.4,99.5,27.1
			c87.4,5,151.6-25.6,192.8-92c31.1,30.2,65.9,53.1,104.6,68.7c38.6,15.5,78.9,23.3,121,23.3c77.3,0,136.7-19.8,178.3-59.2
			c41.6-39.5,62.4-97,62.4-172.6V673.6h-152.5v388.1c0,43.7-7.4,75.2-22,94.5c-14.7,19.3-41.8,29-81.3,29
			c-41.2,0-78.8-10.1-112.8-30.2s-51-50-51-89.5V673.6h-153.7v388.1c0,42.8-7.4,74.1-22.1,93.9c-14.7,19.7-41.4,29.6-80,29.6
			c-45.4,0-84.4-13.7-117.2-40.9c-32.8-27.3-49.1-62.4-49.1-105.2V673.6h-152.5L3382.5,1320"
          />
          <path
            id="path38"
            className="st0"
            d="M4861.7,1370.4c-13.5,13.4-20.2,31.1-20.2,52.9c0,20.2,6.7,37.4,20.2,51.7
			c13.4,14.3,31.9,21.4,55.4,21.4c23.5,0,42-7.2,55.4-21.4c13.4-14.3,20.2-31.5,20.2-51.7c0-21.8-6.7-39.5-20.2-52.9
			c-13.4-13.4-31.9-20.2-55.4-20.2C4893.7,1350.2,4875.2,1356.9,4861.7,1370.4z M4885.1,824.2c34,21.4,51,50.6,51,87.6V971
			l-94.5-3.8c-80.6-3.4-136.9-12.4-168.8-27.1c-31.9-14.7-47.9-37.6-47.9-68.7c0-25.2,10.5-44.7,31.5-58.6
			c21-13.9,52.9-20.8,95.8-20.8C4806.7,792.1,4851,802.8,4885.1,824.2z M4611.6,1372.3c-13,13.9-19.5,31.3-19.5,52.3
			c0,21,6.5,38.4,19.5,52.3c13,13.9,31.3,20.8,54.8,20.8c23.5,0,42-7.2,55.4-21.4c13.4-14.3,20.2-31.5,20.2-51.7
			c0-21.8-6.7-39.5-20.2-52.9c-13.4-13.4-31.9-20.2-55.4-20.2C4642.9,1351.5,4624.7,1358.4,4611.6,1372.3z M4539.2,721.5
			c-44.5,34.4-66.8,85.7-66.8,153.7c0,56.3,16.4,99.1,49.1,128.5c32.8,29.4,75.6,49.1,128.5,59.2c52.9,10.1,117.2,15.5,192.8,16.4
			l93.2,1.3v8.8c0,38.6-10.1,65.1-30.2,79.4c-20.2,14.3-55.9,21.4-107.1,21.4c-42.8,0-76.2-6.3-100.2-18.9s-36.3-36.1-37.2-70.6
			h-156.3c0.8,81.5,27.3,139.9,79.4,175.1c52.1,35.3,123.5,53.3,214.2,54.2c100-0.8,173-21.4,219.2-61.7
			c46.2-40.3,69.3-101.2,69.3-182.7v-412h-151.2V753c-24.4-25.2-54.4-45.4-90.1-60.5c-35.7-15.1-76.7-22.7-122.9-22.7
			C4645,669.8,4583.7,687,4539.2,721.5"
          />
          <path
            id="path40"
            className="st0"
            d="M5198.2,1320h152.5v-78.1c21.8,27.7,53.7,49.3,95.8,64.9c42,15.5,84.8,23.3,128.5,23.3
			c77.3,0,136.7-21.6,178.3-64.9c41.6-43.3,62.4-102.7,62.4-178.3V673.6h-153.7v378c0,46.2-8.8,80-26.5,101.4
			c-17.6,21.4-49.1,32.1-94.5,32.1c-28.6,0-57.5-4.6-86.9-13.9c-29.4-9.3-54-23.8-73.7-43.5c-19.7-19.8-29.6-44.3-29.6-73.7V673.6
			h-152.5V1320"
          />
          <path
            id="path42"
            className="st0"
            d="M6376.2,872.1c32.8,29.8,49.1,69.1,49.1,117.8v29c0,52.9-14.9,94.3-44.7,124.1
			c-29.8,29.8-74.6,44.7-134.2,44.7c-58,0-103.5-15.6-136.7-46.6c-33.2-31.1-49.8-76-49.8-134.8c0-59.6,16.4-104.4,49.1-134.2
			c32.8-29.8,75.6-44.7,128.5-44.7C6297.3,827.3,6343.5,842.2,6376.2,872.1L6376.2,872.1z M5930.2,645.9h147.4
			c6.7-29.4,26-49.6,58-60.5c31.9-10.9,71-16.4,117.2-16.4c54.6,0,96.6,10.5,126,31.5c29.4,21,43.7,57.1,42.8,108.4v79.4
			c-6.7-26.1-28.8-49.4-66.1-69.9c-37.4-20.6-82.1-31.3-134.2-32.1c-97.5,0-174.9,28.3-232.5,85.1c-57.6,56.7-86.3,135.9-86.3,237.5
			c0,98.3,28.5,176.4,85.7,234.4c57.1,58,134.8,86.9,233.1,86.9c37,0,74.1-6.7,111.5-20.2c37.4-13.4,67-29.4,88.8-47.9v58h153.7
			V740.4c0-67.2-9.7-123.9-29-170.1c-20.2-48.7-53.8-84.8-100.8-108.4c-47-23.5-111.3-35.3-192.8-35.3
			C6047.8,426.6,5940.3,499.7,5930.2,645.9"
          />
          <path
            id="path44"
            className="st0"
            d="M6707.6,785.1c15.9,13.9,34.8,20.8,56.7,20.8c21,0,39.5-6.9,55.4-20.8c16-13.9,23.9-33,23.9-57.3
			c0-24.4-8-43.5-23.9-57.3c-16-13.9-34.5-20.8-55.4-20.8c-21.9,0-40.8,6.9-56.7,20.8c-16,13.9-24,32.9-24,57.3
			C6683.7,752.1,6691.7,771.3,6707.6,785.1"
          />
        </g>
      </g>
    </svg>
  );
};
